import { render } from "./tm-login-popup.vue?vue&type=template&id=ab93bb80&scoped=true&ts=true"
import script from "./tm-login-popup.vue?vue&type=script&lang=ts"
export * from "./tm-login-popup.vue?vue&type=script&lang=ts"

import "./tm-login-popup.vue?vue&type=style&index=0&id=ab93bb80&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab93bb80"]])

export default __exports__